import { createFileRoute } from '@tanstack/react-router'
import { EmpresasPage } from '@/pages/empresas/EmpresasPage'

export const Route = createFileRoute('/_auth/empresas')({
  component: EmpresasPage,
})
